import React from 'react';
import { styled } from '@mui/material/styles';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PeopleIcon from '@mui/icons-material/People';
import { useNavigate } from 'react-router-dom';

import { Paper, Typography, Box } from '@mui/material';

const StyledPaper = styled(Paper)(({ theme }) => ({
  cursor: 'pointer',
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
  borderRadius: '12px',
  border: '1px solid rgba(255, 255, 255, 0.05)',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
    borderColor: theme.palette.primary.main,
  },
}));

function GroupListItem({ group }) {

  const navigate = useNavigate();

  const groupClicked = groupId => {
    navigate(`details/${groupId}`);
  }

  return (
    <StyledPaper elevation={0} onClick={() => groupClicked(group.id)}>
      <Box display="flex" justifyContent="space-between" alignItems="flex-start">
        <Typography variant="h3" color="primary" gutterBottom>
          {group.name}
        </Typography>
        <Box display="flex" alignItems="center">
          <PeopleIcon sx={{ mr: 0.5, fontSize: '1rem', color: 'text.secondary' }} />
          <Typography variant="body2" color="text.secondary">
            {group.num_members}
          </Typography>
        </Box>
      </Box>
      <Box display="flex" alignItems="center" mb={1}>
        <LocationOnIcon sx={{ mr: 0.5, fontSize: '1.1rem', color: 'text.secondary' }} />
        <Typography variant="body2" color="text.secondary">
          {group.location}
        </Typography>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden'
      }}>
        {group.description}
      </Typography>
    </StyledPaper>
  );
}

export default GroupListItem;
